import type {
  CreateChannelModelRequest,
  CreateChannelModelResponse,
  DeleteChannelModelResponse,
  ListChannelModelsResponse,
} from '@nadoutong/contracts';
import { opsApiRequest } from './client.ts';

export function listChannelModels(
  params: { channel_id?: string; model?: string },
  fetchImpl: typeof fetch = fetch,
): Promise<ListChannelModelsResponse> {
  const qs = new URLSearchParams();
  if (params.channel_id) qs.set('channel_id', params.channel_id);
  if (params.model) qs.set('model', params.model);
  const query = qs.toString().length > 0 ? `?${qs.toString()}` : '';
  return opsApiRequest<ListChannelModelsResponse>(`/v1/ops/channel-models${query}`, { method: 'GET' }, fetchImpl);
}

export function createChannelModel(
  body: CreateChannelModelRequest,
  fetchImpl: typeof fetch = fetch,
): Promise<CreateChannelModelResponse> {
  return opsApiRequest<CreateChannelModelResponse>('/v1/ops/channel-models', {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    body,
  }, fetchImpl);
}

export function deleteChannelModel(
  channelId: string,
  model: string,
  fetchImpl: typeof fetch = fetch,
): Promise<DeleteChannelModelResponse> {
  return opsApiRequest<DeleteChannelModelResponse>(
    `/v1/ops/channel-models/${channelId}/${model}`,
    { method: 'DELETE' },
    fetchImpl,
  );
}
